import { render } from "./SlotPopper.vue?vue&type=template&id=44999125"
import script from "./SlotPopper.vue?vue&type=script&lang=js"
export * from "./SlotPopper.vue?vue&type=script&lang=js"

import "./SlotPopper.vue?vue&type=style&index=0&id=44999125&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__